import { PermissionScope } from "models/enumerations/notebooks/permission-scope";
import NotebookRecord from "models/view-models/notebook-record";
import { NotebookPermissionService } from "utilities/services/notebooks/notebook-permission-service";
import NotebookService from "utilities/services/notebooks/notebook-service";

interface Options {
    notebook?: NotebookRecord | null;
    recipientsSearchText?: string;
}

const useNotebookPermissionsApi = ({
    notebook,
    recipientsSearchText,
}: Options) => {
    const { create: createNotebookPermissionApi } =
        NotebookPermissionService.useCreate();
    const { update: updateNotebookPermissionApi } =
        NotebookPermissionService.useUpdate();
    const { bulkDelete: deleteNotebookPermissionsApi } =
        NotebookPermissionService.useBulkDelete();
    const { list: listNotebookPermissionsApi } =
        NotebookPermissionService.useListQuery();
    const { list: listRecipientsApi } = NotebookService.useRecipientsQuery();

    const {
        data: availableRecipientsResult,
        isLoading: isLoadingRecipients,
        isFetching: isFetchingRecipients,
    } = listRecipientsApi(
        { searchText: recipientsSearchText },
        { keepPreviousData: true }
    );
    const { data: notebookPermissions, isLoading: isLoadingPermissions } =
        listNotebookPermissionsApi({ notebookId: notebook?.id! }, undefined, {
            enabled: notebook?.id != null,
        });

    const hasSharedNotebookWithEditPermissions =
        notebookPermissions?.resultObjects.some(
            (n) => n.permission.permission === PermissionScope.Edit
        ) ?? false;

    return {
        createNotebookPermissionApi,
        updateNotebookPermissionApi,
        deleteNotebookPermissionsApi,
        availableRecipientsResult,
        notebookPermissions,
        isLoadingPermissions,
        isLoadingRecipients: isLoadingRecipients || isFetchingRecipients,
        hasSharedNotebookWithEditPermissions,
    };
};

export default useNotebookPermissionsApi;
